import {Injectable} from '@angular/core';
import * as Rx from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HttpWrapper {

  private authError = false;

  constructor(private _http: HttpClient, private router:Router) { }

  private count:number = 0;

  /* public _request(method: RequestMethod, url: string, search?:URLSearchParams, body?: any, response?:ResponseContentType, addHeaders:boolean=true, showSpinner:boolean=true): Rx.Observable<Response> {
    let requestOptions = new RequestOptions({
      method: method,
      url: url,
      body: body,
      responseType: response,
      params: search, 
      // headers: addHeaders ? this.createAuthorizationHeader() : null
      headers: null
    });

    return Rx.Observable.create((observer) => {
      this._http.request(new Request(requestOptions))
        .subscribe(
        (res) => {
            observer.next(this.getJson(res));
            observer.complete();
        },
        (err) => {
              throw err; //observer.error(err);
        }
      )
    })
  }

  public request(request:Request, addHeader:boolean=false ): Rx.Observable<Response> {
    if(addHeader)
     // request.headers=this.createAuthorizationHeader();
    return Rx.Observable.create((observer) => {
      this._http.request(request)
        .subscribe(
        (res) => {
            observer.next(this.getJson(res));
            observer.complete();
        },
        (err) => {
              throw err; //observer.error(err);
        }
      )
    })
  } */

  private getJson(res:any){
    try {
      res._body = JSON.parse(res._body); 
    } catch (error) {
      
    }
    return res;
  }

}